import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import IconClose from '@material-ui/icons/Close';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';

import IntlMessageComponent from 'components/formatters/intlMessage';

const useStyles = makeStyles(theme => ({
  button: {
    borderColor: '#fff',
    color: '#fff',
    top: theme.spacing(1)
  },
  closeButton: {
    color: '#fff',
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1)
  },
  icon: {
    color: '#fff'
  },
  itemIcon: {
    minWidth: '40px'
  },
  paper: {
    backgroundColor: theme.palette['primary'].main,
    color: '#fff',
    padding: theme.spacing(2),
  }
}));

export default function ReferralModalComponent(props) {
  const classes = useStyles();

  return (
    <Dialog
      fullWidth  
      maxWidth="md"
      open
      onClose={props.handleClose}
      PaperProps={{ classes: {root: classes.paper } }}
      scroll="body"
    >
      <DialogTitle>
        <Typography variant="h6">
          <IntlMessageComponent id='seller.referral.modal.title' />
        </Typography>
        <IconButton className={classes.closeButton} onClick={props.handleClose}>  
          <IconClose />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box mb={5}>
          <Grid container>
            <Grid item xs={12} lg={6}>
              <Box pr={3}>
                <Typography variant="h3" gutterBottom>
                  <IntlMessageComponent id='seller.referral.modal.left' />
                </Typography>
              </Box>
            </Grid>
            
            <Grid item xs={12} lg={6}>
              <Box mt={1}>
                <Typography variant="body1" gutterBottom>
                  <b><IntlMessageComponent id='seller.referral.modal.list.title' /></b>
                </Typography>

                <List component="nav" aria-label="main mailbox folders">
                  <ListItem alignItems="flex-start">
                    <ListItemIcon className={classes.itemIcon}>
                      <CheckCircleOutlineIcon className={classes.icon} />
                    </ListItemIcon>
                    <ListItemText primary={<Typography variant="body1"><IntlMessageComponent id="seller.referral.modal.list.elem1"/></Typography>} />
                  </ListItem>

                  <ListItem alignItems="flex-start">
                    <ListItemIcon className={classes.itemIcon}>
                      <CheckCircleOutlineIcon className={classes.icon} />
                    </ListItemIcon>
                    <ListItemText primary={<Typography variant="body1"><IntlMessageComponent id="seller.referral.modal.list.elem2"/></Typography>} />
                  </ListItem>

                  <ListItem alignItems="flex-start">
                    <ListItemIcon className={classes.itemIcon}>
                      <CheckCircleOutlineIcon className={classes.icon} />
                    </ListItemIcon>
                    <ListItemText primary={<Typography variant="body1"><IntlMessageComponent id="seller.referral.modal.list.elem3"/></Typography>} />
                  </ListItem>
                </List>
              </Box>

              <Button
                className={classes.button}
                variant="outlined"
                onClick={props.handleClose}
              ><IntlMessageComponent id='seller.referral.modal.btn.recommend' /></Button>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  );
}